import Vue from 'vue'

import searchPanel from './searchPanel'
import artEdit from './artEdit'
import card from './card'
import workOrderCard from "./workOrderCard/index"
import workOrderBaseInfo from "./workOrderBaseInfo/index"
import workOrderApplyInfo from "./workOrderApplyInfo/index"
import workOrderMoreInfo from "./workOrderMoreInfo/index"
import workOrderUserInfo from "./workOrderUserInfo/index"
import workOrderStepInfo from "./workOrderStepInfo/index"
import workOrderStatusInfo from "./workOrderStatusInfo/index"
import workOrderUserSelect from "./workOrderUserSelect/index"
import workOrderUserSelectV2 from "./workOrderUserSelectV2/index"
import workOrderTagInfo from "./workOrderTagInfo/index"
import workOrderEditor from "./workOrderEditor/index"
import workOrderFileUpload from "./workOrderFileUpload/index";
import workOrderImageUpload from "./workOrderImageUpload/index";
import workOrderProcess from "./workOrderProcess/index";
import workOrderTransfer from "./workOrderTransfer/index";
import workOrderTool from ".//workOrderTool/index";
import tempDialog from ".//tempDialog/index.vue";

Vue.component('m-search-panel', searchPanel);
Vue.component('m-art-edit', artEdit);
Vue.component('m-card', card);
Vue.component('work-order-card', workOrderCard);
Vue.component('work-order-base-info', workOrderBaseInfo);
Vue.component('work-order-apply-info', workOrderApplyInfo);
Vue.component('work-order-more-info', workOrderMoreInfo);
Vue.component('work-order-user-info', workOrderUserInfo);
Vue.component('work-order-step-info', workOrderStepInfo);
Vue.component('work-order-status-info', workOrderStatusInfo);
Vue.component('work-order-user-select', workOrderUserSelect);
Vue.component('work-order-user-select-v2', workOrderUserSelectV2);
Vue.component('work-order-tag-info', workOrderTagInfo);
Vue.component('work-order-editor', workOrderEditor);
Vue.component('work-order-file-upload', workOrderFileUpload);
Vue.component('work-order-image-upload', workOrderImageUpload);
Vue.component('work-order-process', workOrderProcess);
Vue.component('work-order-transfer', workOrderTransfer);
Vue.component('work-order-tool', workOrderTool);
Vue.component('temp-dialog', tempDialog);
